import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BillingserviceService } from 'app/billing/billingService.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { InvestigationServicesComponent } from 'app/EMR/Doctor/investigation-services/investigation-services.component';
import { InvestigationModel } from 'app/EMR/DoctorModels/investigation.model';
import { EMRService } from 'app/EMR/EMR.service';
import { Subject } from 'rxjs';
import {  takeUntil } from 'rxjs/operators';
import { HelplistService } from 'app/helplist.service';
@Component({
  selector: 'app-advised-investigations',
  templateUrl: './advised-investigations.component.html',
  styleUrls: ['./advised-investigations.component.scss']
})
export class AdvisedInvestigationsComponent implements OnInit {
  destroyadvised$: Subject<boolean> = new Subject<boolean>();
  displayedColumns_optoInvestdetails: string[] = ['service', 'eye', 'Action'];
  displayedColumns_add_optoInvestdetails: string[] = ['service', 'eye', 'Action'];
  private AddServiceArray: any = [];
  optoInvestdetails: MatTableDataSource<InvestigationModel>;
  private add_optoInvestdetails: any;
  private optoInvestigationdata: any = [];
  private editCache: { [key: string]: any } = {};
  private servicelist: any[];
  private filteredServices: any[] = [];
  private ServiceID: any;
  private siteType: any;
  private enabledisablebtn:boolean =false;
  constructor(private dialog: MatDialog, private billingservice: BillingserviceService, private helplistservice: HelplistService,
    private dashboardService: DashboardService, private emrservice: EMRService) { }

  ngOnInit(): void {
    this.enabledisablebtn =true;
   
    this.getServiceList();
    this.emrservice.share.pipe(takeUntil(this.destroyadvised$)).subscribe((x: any) => {
      if(x==3){
        this.enabledisablebtn =true;
        this.optoInvestDetails(); 
      }
    })
    this.emrservice.aishare.pipe(takeUntil(this.destroyadvised$)).subscribe((x: any) => {
      if(x=='section16'){
        this.enabledisablebtn =true;
        this.optoInvestDetails();
      }
    });
   
  }
  ngOnDestroy(){
    this.destroyadvised$.next(true);
    this.destroyadvised$.unsubscribe();
    this.AddServiceArray=null;
    this.optoInvestigationdata=null;
    this.servicelist=null;
    this.filteredServices = null;
    this.displayedColumns_optoInvestdetails=null;
    this.displayedColumns_add_optoInvestdetails=null;
  }
  optoInvestDetails() {
   this.emrservice.getOptoInvestigationsDetail().pipe(takeUntil(this.destroyadvised$)).subscribe(data => {
      this.emrservice.optoInvDetails = data;
      this.optoInvestdetails = new MatTableDataSource(this.emrservice.optoInvDetails.slice());
      this.InvestupdateEdit();
    },err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }

  addService() {
   // this.AddServiceArray = [];
   if (this.emrservice.advisedInvestigationsPermission?.isAddPermission == true) {
    const dialogRef = this.dialog.open(InvestigationServicesComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '100vw !important',
      maxHeight: '90%',
      width: '80%',
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyadvised$)).subscribe(result => {
      var result = this.emrservice.selectedInvestigationRow.reduce((unique, o) => {
        if (!unique.some(obj => obj.serviceName === o.serviceName && obj.serviceId === o.serviceId)) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (result.length > 0) {

      }

      if (result.length > 0) {
        result.forEach((element, index) => {
          this.AddServiceArray.push({
            'pK_TranId': 0,
            "serviceName": element.serviceName,
            "fK_ServiceId": element.serviceId,
            "Result": element.Comments,
            "isEdit": false,
            'Academic': false,
            "isDeleted": 0,
            'eye':''
          });
          // 
        });
        this.AddServiceArray = this.AddServiceArray.reduce((unique, o) => {
          if (!unique.some(obj => obj.serviceName === o.serviceName && obj.fK_ServiceId === o.fK_ServiceId)) {
            unique.push(o);
          }
          return unique;
        }, []);

        const index = this.AddServiceArray.filter(list => list.fK_ServiceId == 0);
        if (index.length > 0) {
          this.AddServiceArray.splice(index, 1);
        }
        this.add_optoInvestdetails = new MatTableDataSource(this.AddServiceArray.slice());

        // res.forEach(item => {
        //   this.optoInvestdetails.data.push(item);
        // });

        // this.optoInvestdetails.data = [...this.optoInvestdetails.data];
      }
      // this.cancelAdvisedInvestOpto();
      this.uploadOptoDetails();
    });

    // if (this.siteType == '') {
    //   this.dashboardService.openSnackBar("Please Select Site", "OK");
    // }
    // else {

    // }
  }else {
    this.dashboardService.openSnackBar("Add permission denied", "OK");
  }
  }

  onSitechange(e: any, index: number) {
    if (e != null) {
      this.AddServiceArray[index].eye = e;
      this.add_optoInvestdetails.data = this.AddServiceArray;
    }
  }

  saveOptoInvestigation() {
    if(this.emrservice.advisedInvestigationsPermission.isAddPermission ==true){
  this.optoInvestigationdata = [];
    this.emrservice.open_loader_Dialog();
    this.optoInvestdetails.data.forEach(item => {
      this.optoInvestigationdata.push({
        "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
        "FK_VisitId": this.emrservice.visitid,
        "FK_ServiceId": item.fK_ServiceId,
        "Result": item.Comments,
        "Eye": item.eye,
        "Academic": item.Academic,
        "PK_SynchId": 0,
        "IsEdit": false,
        "IsDelete": false
      });
    });

    let InvestigationArray = this.optoInvestigationdata.filter(item => item.PK_TranId == 0);
    if (InvestigationArray.length != 0) {
      const optoInvPayload = {
        "OpdOptoInvestigationsDetail": InvestigationArray
      }
      this.emrservice.saveOpdOptoInvestigationsDetail(optoInvPayload).pipe(takeUntil(this.destroyadvised$)).subscribe(data => this.success_invdetails(data), err => this.failed_invdetails(err));
    } else {
      this.dialog.closeAll();
      this.dashboardService.openSnackBar("Please Add Investigation", "OK");
    }
  }else{
    this.dashboardService.openSnackBar("Add Permission Denied", "OK");
  }
  }

  success_invdetails(data) {
    if (data['statusCode'] == 10) {
      this.dashboardService.openSnackBar("This record is already exists","OK");
      this.dialog.closeAll();
    }else{
      this.dialog.closeAll();
      this.enabledisablebtn =true;
      this.emrservice.getPExamStatus();
      this.optoInvestDetails();
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK"); 
    }

  }

  failed_invdetails(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  deleteAddrow(row) {
    if(this.emrservice.advisedInvestigationsPermission.isDeletePermission ==true){
    this.emrservice.open_loader_Dialog();
    if (row.pK_TranId > 0) {
      row.isEdit = true
      row.isDelete = true
      let payload = {
        "OpdOptoInvestigationsDetail": [row]
      }
       this.emrservice.saveOpdOptoInvestigationsDetail(payload).pipe(takeUntil(this.destroyadvised$)).subscribe(
        data => this.success_delete_optoInv(data), err => this.failed_delete_optoInv(err)
      )
    }
    else {
      const index: number = this.optoInvestdetails.data.indexOf(row);
      if (index !== -1) {
        this.optoInvestdetails.data.splice(index, 1);
        this.optoInvestdetails.data = this.optoInvestdetails.data.slice();
      }
      this.dialog.closeAll();
    }
  }else{
    this.dashboardService.openSnackBar("Delete Permission Denied", "OK"); 
  }
  }

  deleteFromAdd(row) {
    const index: number = this.add_optoInvestdetails.data.indexOf(row);
    if (index !== -1) {
      this.add_optoInvestdetails.data.splice(index, 1);
      this.add_optoInvestdetails.data = this.add_optoInvestdetails.data.slice();
      this.AddServiceArray = this.add_optoInvestdetails.data;
    }
  }

  success_delete_optoInv(data) {
    this.enabledisablebtn =true;
    this.dialog.closeAll();
    this.optoInvestDetails();
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
  }

  failed_delete_optoInv(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  uploadOptoDetails() {
    if(this.add_optoInvestdetails.data == undefined || this.add_optoInvestdetails.data.length == 0 ){
      return this.dashboardService.openSnackBar("Please Select Investigation", "OK");
    }
    // let checkeye = this.add_optoInvestdetails.data.filter(item => item.eye == '');
    // if (checkeye.length != 0) {
    //   return this.dashboardService.openSnackBar("Please Select Site", "OK");
    // }
    let results: any;
    this.optoInvestdetails.data =this.add_optoInvestdetails.data;
    // this.add_optoInvestdetails.data.forEach(item => {
    //   this.optoInvestdetails.data.push(item);
    // });

    results = this.optoInvestdetails.data.reduce((unique, o) => {
      if (o.pK_TranId == 0) {
        if (!unique.some(obj => obj.serviceName === o.serviceName && obj.fK_ServiceId === o.fK_ServiceId && obj.eye === o.eye)) {
          unique.push(o);
        }
      }
      return unique;
    }, []);
    this.enabledisablebtn =false;
    let getdata = this.optoInvestdetails.data.filter(item => item.pK_TranId != 0);
    this.optoInvestdetails.data = getdata.concat(results);
    this.InvestupdateEdit();
    this.cancelAdvisedInvestOpto();
  }
  addAdvisedInvestOpto() {
    if(this.emrservice.advisedInvestigationsPermission.isAddPermission ==true){
    document.getElementById("addInvestigationDetailsModal").style.display = "block";
    this.siteType = '';
    this.add_optoInvestdetails = [];
    this.emrservice.optoInvDetails = [];
    this.AddServiceArray =[];
    }else{
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }

  cancelAdvisedInvestOpto() {
    document.getElementById("addInvestigationDetailsModal").style.display = "none";
  }
    // Investigation edit part
    InvestupdateEdit(): void {
   
      this.optoInvestdetails.data?.forEach((item, index) => {
        const id = index;
        this.editCache[id] = {
          edit: false,
          data: { ...item }
        };
     
      });
  
    
    }
  
    InvestEdit( index) {
      if(this.emrservice.advisedInvestigationsPermission.isModifyPermission ==true){
      const id =index;
      this.InvestupdateEdit();
      this.editCache[id].edit = true;
   
      this.getServiceList();
      this.ServiceID = '';      
      }else{
        this.dashboardService.openSnackBar("Modify Permission Denied","ok");
      }
    }
  
    InvestSaveEdit(idx): void {
      
      const id = idx; 
      let payloadInvestarray = [];   
      let isedit
      let fK_ServiceId
      let editInvestlist =  this.editCache[id].data;
      if (editInvestlist.pK_TranId == 0) {     
        isedit = false;
        fK_ServiceId = this.ServiceID == ""?  editInvestlist.fK_ServiceId : this.ServiceID;
      } else {      
        isedit = true; 
        fK_ServiceId = this.ServiceID == ""?  editInvestlist.fK_ServiceId : this.ServiceID;   
      }
  
      payloadInvestarray.push({   
        "PK_TranId": editInvestlist.pK_TranId,
        "FK_VisitId": this.emrservice.visitid,
        "FK_ServiceId": fK_ServiceId,
        "Result": editInvestlist.Comments,
        "Eye": editInvestlist.eye,
        "Academic": editInvestlist.Academic,
        "PK_SynchId": 0,      
        "IsEdit": isedit,
        "IsDelete": false
  
        
      })
      this.editCache[id].edit = false
      let editInvestpayload = {
        "OpdOptoInvestigationsDetail": payloadInvestarray
      }
  
    this.emrservice.saveOpdOptoInvestigationsDetail(editInvestpayload).pipe(takeUntil(this.destroyadvised$)).subscribe(
        data => this.success_Invest_update(data), err => this.failed_Invest_update(err)
      )
    }
    success_Invest_update(data) {   
      if (data['statusCode'] == 10) {
        this.dashboardService.openSnackBar("This record is already exists","OK");
      }else{
        this.optoInvestDetails();
        this.emrservice.getPExamStatus();  
        this.dashboardService.openSnackBar("Record Updated Successfully", "OK"); 
      }
    }
    failed_Invest_update(err) {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    }
  
    InvestcancelEdit( idx): void {
      const id = idx;
      this.editCache[id].edit = false;
    }
  
    getServiceList(){
  
      this.servicelist=[];     
    
     this.billingservice.getserviceByDepartmentId(0,0,1,1).pipe(takeUntil(this.destroyadvised$)).subscribe((data: any[])=>{
  
        this.servicelist = data;
      
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }

    filterServices(value: string) {
      const filterValue = value.toLowerCase();
      this.filteredServices = this.servicelist.filter(service =>
        service.serviceName.toLowerCase().includes(filterValue)
      );
    }

    SelectserviceIdName(event){
  this.ServiceID = event.option.id;
  
    }
    
}
